import { createSlice } from "@reduxjs/toolkit";

const initialState = {  bookMarkClass: false};

export const BookmarkSlice = createSlice({
  name: "bookmark",
  initialState,
  reducers: {
    setBookMarkClass: (state, action) => {
      state.bookMarkClass = action.payload;
    },
  },
});

export const { setBookMarkClass } = BookmarkSlice.actions;
export default BookmarkSlice.reducer;
